/** Shared class names for the setup and onboarding UI. */
export const SETUP_CARD = 'rounded-xl bg-(--color-bg-secondary) border border-(--color-border) p-4 flex flex-col gap-3';
export const PRIMARY_BUTTON =
  'px-4 py-2 rounded-lg text-sm font-semibold bg-green-400 text-gray-900 hover:bg-green-300 disabled:opacity-40 disabled:cursor-not-allowed transition-colors';
export const SECONDARY_BUTTON =
  'px-4 py-2 rounded-lg text-sm font-medium border border-(--color-border) text-(--color-text-secondary) hover:text-(--color-text-primary) hover:border-gray-400 disabled:opacity-40 transition-colors';
export const MUTED = 'text-sm text-(--color-text-secondary)';
